import angular from 'angular';

import RwPhoneComponent from './rw-phone-component';
import { RwPhoneController } from './rw-phone-controller';

export default angular
  .module('rw-phone', ['lsp-filters'])
  .controller('RwPhoneController', RwPhoneController)
  .component('rwPhone', RwPhoneComponent);



// WEBPACK FOOTER //
// ./src/modules/utils/rw-phone/rw-phone-module.js